module.exports = __webpack_public_path__ + "img/japaneseasmr-logo.9fcda5e6.png";